import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, type OnDestroy, Output, ViewRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { Login } from '@df/session/login/login.interfaces';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { Subscription } from 'rxjs/internal/Subscription';
import { TranslateHtmlDirective } from '../../ui/common/translate-html.directive';
import { CheckboxComponent } from '../../ui/form/checkbox';
import { CheckoutFormComponent } from '../checkout-form.component';

@Component({
    selector: 'checkout-newsletter',
    templateUrl: './checkout-newsletter.component.html',
    standalone: true,
    imports: [CheckboxComponent, FormsModule, TranslateHtmlDirective, RouterModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutNewsletterComponent implements OnDestroy {
    @Input()
    data: Partial<Login.ILoginFormData | Login.IRegisterFormData | Login.IResetPasswordFormData> = {};

    @Input()
    source!: string;

    @Output()
    dataChange = new EventEmitter<boolean>();

    showSubscriptionOptOut = false;

    protected subscriptions = new Subscription();

    private _newsletter?: boolean;

    constructor(
        protected changeDetectorRef: ChangeDetectorRef,
        protected checkoutFormComponent: CheckoutFormComponent
    ) {
        this.subscriptions.add(
            this.checkoutFormComponent.subscriptionChange$.pipe().subscribe(value => {
                this._newsletter = !!value;

                this.detectChanges();
            })
        );
    }

    get newsletter(): boolean | undefined {
        return this._newsletter === undefined ? undefined : this.checkoutFormComponent?.data?.newsletter;
    }

    set newsletter(value: boolean) {
        this._newsletter = value;
        this.checkoutFormComponent.setNewsletter(value, this.source);
    }

    /**
     * On destroy hook
     */
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    ngModelChangeHandle(value: boolean) {
        if (this.newsletter !== value) {
            this.newsletter = value;

            this.dataChange.emit(value);
        }
    }

    showSubscriptionOptOutHandle() {
        this.showSubscriptionOptOut = !this.showSubscriptionOptOut;

        this.detectChanges();
    }

    protected detectChanges() {
        if (!(<ViewRef>this.changeDetectorRef).destroyed) {
            this.changeDetectorRef.detectChanges();
        }
    }
}
